import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import { Component } from 'intact-vue';
export var MemoBlock = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MemoBlock, _Component);
  function MemoBlock() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = MemoBlock.prototype;
  _proto.$update = function $update(lastVNode, nextVNode, parentDom, anchor, mountedQueue, force) {
    var lastProps = lastVNode.props;
    var nextProps = nextVNode.props;
    if (lastProps.block === nextProps.block) return;
    _Component.prototype.$update.call(this, lastVNode, nextVNode, parentDom, anchor, mountedQueue, force);
  };
  return MemoBlock;
}(Component);
MemoBlock.template = function () {
  var props = this.$props;
  return props.children;
};